import * as classroomApi from '../api/classroomApi';
import FileDownloaderService from '../stream/FileDownloadService';
import { getStudentPinCode } from '../api/userApi';
import { getLogger } from '../logger';

const debug = getLogger('services:domain:pinCodesDownloadService');

export function downloadFileOfStudentOrClassroom(student, classroom) {
  if (!student) {
    classroomApi
      .getClassroomStudentPinCodes(classroom.sectionId, true)
      .then(dataStream => {
        FileDownloaderService.downloadFromRawBinaryStream(dataStream.data, `${classroom.name}_pincode`, '.pdf');
      })
      .catch(err => {
        debug.error('error downloading classroom pin codes %s', err);
      });
  } else {
    getStudentPinCode(student._id, true)
      .then(dataStream => {
        FileDownloaderService.downloadFromRawBinaryStream(
          dataStream.data,
          `${student.name}-${student.surname}_pincode`,
          '.pdf'
        );
      })
      .catch(err => {
        debug.error('error downloading student pin codes', err);
      });
  }
}
